import { createContext } from 'preact';

type InputGroupContextProps = {
  index: number;
  last: boolean;
};

/**
 * Context used to determine if component is within an InputGroup
 */
const InputGroupContext = createContext<InputGroupContextProps | null>(null);

InputGroupContext.displayName = 'InputGroupContext';

export { InputGroupContext, InputGroupContextProps };
